import { ServiceSeriesKey } from '../utils/receptionStats'

/** Chart series — one consistent colour per service across every chart. */
export const serviceSeries: Array<{
  key: ServiceSeriesKey
  label: string
  color: string
}> = [
  { key: 'register', label: 'Register New', color: '#221587' },
  { key: 'gyne', label: 'Gyne Consultation', color: '#2563EB' },
  { key: 'general', label: 'General Consultation', color: '#8B2BE2' },
  { key: 'lab', label: 'Laboratory', color: '#F0157D' },
  { key: 'radiology', label: 'Radiology', color: '#E8830C' },
  { key: 'maternity', label: 'Maternity', color: '#0D9488' },
]
